import styled from "styled-components";

const DashboardChartStyle = styled.div`
  height: 240px;
  width: 100%;
`;

export default DashboardChartStyle;